var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.alt,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    },
                    {
                        text: _vm.currentPage.images.oImage1.text,
                        position: 'bottom-left', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-selective_green',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-lg mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('TitleParagraph',{staticClass:"mt-8",attrs:{"options":{
                    from: 'from-selective_green',
                    to: 'to-golden_sand',
                }}},[_c('p',{staticClass:"mt-8 text-xl lg:text-3xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleOne.text)}})]),_c('div',{staticClass:"container-components mt-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative pt-6"},[_c('hotspot-richmedia',{staticClass:"-top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'SuPerHydro - Le Fil Express DPIH n°16 - 2 mai 2011'
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Content
                                    .text
                            )}})])],1)]),_c('div',{staticClass:"\n                    container-timeline-title-si-image-with-description-second-2\n                    card\n                    relative\n                    mt-8\n                "},[_c('div',{staticClass:"relative w-full h-full"},[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage2.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage2.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}}),_c('div',{staticClass:"q10__textInImage"},[_c('h2',{staticClass:"\n                                absolute\n                                inline-block\n                                w-auto\n                                top-0\n                                left-0\n                                font-bold\n                                transform\n                                text-nandor\n                                lg:text-white\n                                -rotate-90\n                                text-right\n                                origin-top-right\n                                text-xl\n                                xl:text-3xl\n                                leading-5\n                                -translate-x-full\n                            ",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Title.text
                            )}}),_c('p',{staticClass:"q10__paragraph",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Quote.text
                            )}})])],1)]),_c('TitleParagraph',{staticClass:"mt-8",attrs:{"options":{
                    from: 'from-selective_green',
                    to: 'to-golden_sand',
                }}},[_c('p',{staticClass:"mt-8 text-xl lg:text-3xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleTwo.text)}})]),_c('div',{staticClass:"timeline hidden lg:flex"},[_c('div',{staticClass:"flex text-nandor w-full mt-2"},[_c('div',{staticClass:"\n                            w-1/3\n                            border-r-2 border-nandor\n                            mr-2\n                            text-right\n                            p-2\n                            text-base\n                        ",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content
                                .sParagraphThree_Title_ColOne_Years.text
                        )}}),_c('div',{staticClass:"inline-block p-2 w-2/3"},[_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColOne_Title.text
                            )}}),_c('div',{staticClass:"text-base",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColOne_Content
                                    .text
                            )}})],1)]),_c('div',{staticClass:"flex text-nandor w-full mt-2"},[_c('div',{staticClass:"\n                            w-1/3\n                            border-r-2 border-nandor\n                            mr-2\n                            text-right\n                            p-2\n                            text-base\n                        ",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content
                                .sParagraphThree_Title_ColTwo_Years.text
                        )}}),_c('div',{staticClass:"inline-block p-2 w-2/3"},[_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColTwo_Title.text
                            )}}),_c('div',{staticClass:"text-base",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColTwo_Content
                                    .text
                            )}})],1)]),_c('div',{staticClass:"flex text-nandor w-full mt-2"},[_c('div',{staticClass:"\n                            w-1/3\n                            border-r-2 border-nandor\n                            mr-2\n                            text-right\n                            p-2\n                            text-base\n                        ",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content
                                .sParagraphThree_Title_ColThree_Years.text
                        )}}),_c('div',{staticClass:"inline-block p-2 w-2/3"},[_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColThree_Title
                                    .text
                            )}}),_c('div',{staticClass:"text-base",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColThree_Content
                                    .text
                            )}})],1)])]),_c('div',{staticClass:"timeline flex flex-col lg:hidden"},[_c('div',{staticClass:"flex text-nandor w-full mt-2"},[_c('div',{staticClass:"w-1/2 flex"},[_c('img',{staticClass:"mx-auto w-12 h-12 m-3",attrs:{"src":_vm.$i18n.locale +
                                '/images/pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                'sageata_verde.png'}}),_c('div',{staticClass:"\n                                border-r-2 border-nandor\n                                mr-2\n                                text-right\n                                p-2\n                                text-base\n                                inline-block\n                            ",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColOne_Years.text
                            )}})]),_c('div',{staticClass:"inline-block p-2 w-1/2"},[_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColOne_Title.text
                            )}}),_c('div',{staticClass:"text-base",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColOne_Content
                                    .text
                            )}})],1)]),_c('div',{staticClass:"flex text-nandor w-full mt-2"},[_c('div',{staticClass:"w-1/2 flex"},[_c('img',{staticClass:"mx-auto w-12 h-12 m-3",attrs:{"src":_vm.$i18n.locale +
                                '/images/pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                'sageata_verde.png'}}),_c('div',{staticClass:"\n                                border-r-2 border-nandor\n                                mr-2\n                                text-right\n                                p-2\n                                text-base\n                                inline-block\n                            ",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColTwo_Years.text
                            )}})]),_c('div',{staticClass:"inline-block p-2 w-1/2"},[_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColTwo_Title.text
                            )}}),_c('div',{staticClass:"text-base",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColTwo_Content
                                    .text
                            )}})],1)]),_c('div',{staticClass:"flex text-nandor w-full mt-2"},[_c('div',{staticClass:"w-1/2 flex"},[_c('img',{staticClass:"mx-auto w-12 h-12 m-3",attrs:{"src":_vm.$i18n.locale +
                                '/images/pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                'sageata_verde.png'}}),_c('div',{staticClass:"\n                                border-r-2 border-nandor\n                                mr-2\n                                text-right\n                                p-2\n                                text-base\n                                inline-block\n                            ",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColThree_Years.text
                            )}})]),_c('div',{staticClass:"inline-block p-2 w-1/2"},[_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColThree_Title.text
                            )}}),_c('div',{staticClass:"text-base",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Title_ColThree_Content
                                    .text
                            )}})],1)])]),_c('div',{staticClass:"hidden lg:block"},[_c('img',{staticClass:"mx-auto",attrs:{"src":_vm.$i18n.locale +
                        '/images/pages/' +
                        _vm.currentPage.slug +
                        '/' +
                        _vm.currentPage.images.oImage3.src}})]),_c('div',{staticClass:"container-components mt-8"},[_c('div',{staticClass:"card",staticStyle:{"padding":"0"}},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"card break-inside-avoid",staticStyle:{"padding":"0"}},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFive_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFive_Content
                                    .text
                            )}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage4.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage4
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage4
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Histoire de la téléconduite hydraulique par Vincent Breuil'
                            ),
                        }}}),_c('article-note',{staticStyle:{"overflow":"visible"},attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage5.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage5.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: _vm.currentPage.images.oImage5.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                            verticalcontent:
                                _vm.currentPage.content.sParagraphSix_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphSix_Quote
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl lg:text-3xl',
                                content: '',
                            },
                            margin: {},
                        }}})],1)]),_c('div',{staticClass:"mt-8 relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                        icon: 'diaporama',
                        collection: _vm.getRichmediaByCollection(
                            _vm.currentPage,
                            'Le projet national MRCD'
                        ),
                    }}}),_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage6.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage6.alt,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage6.text,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1),_c('TitleParagraph',{staticClass:"mt-8",attrs:{"options":{
                    from: 'from-selective_green',
                    to: 'to-golden_sand',
                }}},[_c('p',{staticClass:"mt-8 text-xl lg:text-3xl 2xl:text-4xl font-bold",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleThree.text)}})]),_c('div',{staticClass:"container-components mt-8"},[_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSeven_Title
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSeven_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"card"},[_c('div',{staticClass:"break-inside-avoid"},[_c('div',{staticClass:"relative pt-14"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        'Etudes de dangers, exporter la sûreté à la française'
                                    ),
                                }}})],1),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content
                                        .sParagraphEight_Title.text
                                )}})])],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphEight_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative pt-10"},[_c('hotspot-richmedia',{staticClass:"-top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Débit réservé : objectif, mise en conformité'
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphNine_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphNine_Content
                                    .text
                            )}}),_c('router-link',{attrs:{"to":{
                                name: 'catalogue',
                                params: { slug: 'page-035' },
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphNine_Content_03.text
                            )}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphNine_Content_02.text
                            )}})],1)],1)]),_c('div',{staticClass:"mt-8"},[_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage7.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage7.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage7.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }